import React from 'react'
import ComingSoon from '../../../components/ComingSoon/ComingSoon'
import Support from '../../../components/AdminSupport/Support'

const AdminSupport = () => {
  return (
    <div>
      <Support />
    </div>
  )
}

export default AdminSupport